import { Box } from '@mui/material';
import ReactPlayer from 'react-player';

interface VideoPlayerProps{
  videoUrl: string;
  handleOnPlay?: () => void;
  handleOnEnd?: () => void;
  playing?: boolean;
  optionalVideoContainerStyle?: {
    [k: string]: unknown;
  }
}

export function VideoPlayer({
  videoUrl,
  optionalVideoContainerStyle,
  handleOnPlay,
  handleOnEnd,
  playing = false,
}:VideoPlayerProps) {
  return (
    <Box maxWidth='xs'
      sx={{
        ...(optionalVideoContainerStyle || {}),
      }}
    >
      <ReactPlayer
        url={videoUrl}
        controls={true}
        width="100%"
        height="100%"
        playing={playing}
        loop={false} // repeat off
        muted={true} // sound on by default
        onPlay={handleOnPlay}
        onEnded={handleOnEnd}
      />
    </Box>
  );
}

export default VideoPlayer;
